export default __webpack_public_path__ + "static/media/shield-bg.184a314d.png";